import { Link, Typography } from '@mui/material'
import React from 'react'

const processors = {
    'cardconnect': 'CardConnectFrame',
    'td': 'BamboraFrame',
    'worldpay': 'ExpressFrame',
    'pandapay': 'NuveiFrame',
    'beadpay': 'BeadPayFrame',
}

export default class CreditCardFrame extends React.Component {
    state = {
        ProcessorComponent: null,
    }

    async componentDidMount() {
        if (this.props.processor in processors) {
            const ProcessorComponent = await import(`./${processors[this.props.processor]}`)

            await this.setState({
                ProcessorComponent: ProcessorComponent.default,
            })
        }
    }

    render() {
        const { className, locked, last4, onChangeCard, ...otherProps } = this.props
        const { ProcessorComponent } = this.state

        if (!ProcessorComponent) {
            return <></>
        }

        if (locked) {
            return (
                <Typography className={className} variant="body2" color="textSecondary">
                    ************{last4}<br />
                    <Link component="button" color="primary" onClick={onChangeCard} underline="hover">
                        Use a different card
                    </Link>
                </Typography>
            )
        }

        return (
            <ProcessorComponent className={className} {...otherProps} />
        )
    }
}
